import axios from "axios";
import React, { useContext, useEffect, useState } from "react";
import { useHistory } from "react-router";
import styled from "styled-components";
import { UserContext } from "../UserContext";

const Home = () => {
  const [balance, setBalance] = useState(0);
  const [total_users, setTotal_Users] = useState(0);
  const history = useHistory();

  const [user] = useContext(UserContext);
  const getUsers = async () => {
    let total = 0;
    const users = await axios.get(
      "https://salt-neobank.herokuapp.com/admin/home"
    );
    users.data.forEach((user) => {
      total = total + user.balance;
    });
    setBalance(total);
    setTotal_Users(users.data.length);
  };
  useEffect(() => {
    if (user.role === "unauthenticated") {
      history.push("/");
    } else {
      getUsers();
    }
  }, [history, user.role]);
  return (
    <Container>
      <Section>
        <h3>Total Bank Balance</h3>
        <h4>${balance}</h4>
      </Section>
      <Section>
        <h3>Total Users</h3>
        <h4>{total_users}</h4>
      </Section>
    </Container>
  );
};
const Container = styled.div``;
const Section = styled.div`
  margin: 1em;
`;
export default Home;
